import { BlankContent } from '@cint/wonderment';

export const MaintainceMessage = () => (
  <BlankContent
    description="When the panel is in Maintenance mode the feature won't be available. This functionality is only accessible when the panel is in Live mode."
    title=""
  />
);
